import { Box } from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { HRService } from "../../../../config";
import PayComponentForm from "./PayForm";
import { payComponentsColumns } from "../../../../data/Columns/hrmanagement";
import { PayComponent } from "../../../../data/Queries/HRmanagement/leavemanagement";

const base_url = HRService.uri;

const actions = {
  entity: "Payroll Setup",
  isSubright:true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  showStatus: true,
};

function PayComponentTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Pay Component"
          subtitle="View all Pay Components, create or update them"
          columns={payComponentsColumns}
          FormComponent={PayComponentForm}
          query={PayComponent}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default PayComponentTable;